// Youngest age these forms will collect a date of birth for. Deliberately
// stricter than the backend's own bound (User::MINIMUM_AGE, matched to
// StackUp's Member::MINIMUM_AGE of 10) — that direction is safe, since
// anything this picker allows the model also accepts. Loosening this to match
// the backend exactly is a product decision, not a data-integrity one.
//
// A rolling bound rather than a fixed cut-off date, so "at least 18" stays true
// as years pass instead of quietly becoming "at least 20".
export const MINIMUM_AGE = 18

export const latestBirthdateAsDate = (): Date => {
  const date = new Date()
  date.setFullYear(date.getFullYear() - MINIMUM_AGE)
  return date
}

// Built from local date parts on purpose: toISOString() converts to UTC first,
// which shifts the day either side of midnight and would offer or withhold a
// date the backend disagrees about.
export const latestBirthdate = (): string => {
  const date = latestBirthdateAsDate()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}
